// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6979":"b199d8b2","9282":"dfa5131b"}[chunkId] + ".chunk.css";
};